// @flow

import React from 'react'
import { styles as s } from './style'
import './buttonLoader.css'

export default function Footer (props: {
  onCheckout: Function,
  totalPrice: Object,
  isLoading: boolean,
}): React.Element<any> {
  return (
    <div style={s.footer}>
      <div style={s.container}>
        <table style={s.totalPriceTable}>
          <tbody>
            <tr>
              <td style={s.orderTotalTitle}>Order Total</td>
              <td style={s.orderTotalValue}>$ { props.totalPrice ? props.totalPrice : 0 }</td>
            </tr>
          </tbody>
        </table>

        <button
          onClick={props.onCheckout}
          style={s.submitButton}
        >
          {
            props.isLoading
              ? <span className='order-flow-button-loader'>
                <div className='loading-dots--dot' />
                <div className='loading-dots--dot' />
                <div className='loading-dots--dot' />
              </span>
              : 'Checkout'
          }
        </button>
      </div>
    </div>
  )
}
